module.exports = __webpack_public_path__ + "img/img62.e4ea9dc7.svg";